module.exports = __webpack_public_path__ + "static/media/jeopardy-min.84461aae.gif";